import {defineStore} from 'pinia';
import {ModuleProject} from '../moduleConst';
import ProjectAPI from '@/apis/di/projectAPI';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import {filter} from '@/mixins/common/filter';
import resouce from '@/commons/wildcards/constants/DefaultValue.js';
import _ from 'lodash';

const projectStore = new BaseDictionaryStore(ProjectAPI);
export const useProjectStore = defineStore(ModuleProject, {
  state: () => ({
    ...projectStore.state,
    _config: {
      key: 'project_id',
      code: 'project_code',
      name: 'project_name',
      table: 'di_project',
      quickFollow: 'active',
      defaultSort: 'misa_code_id',
      isTree: true,
      // hasDataOrigin: true,
      moduleName: 'Chương trình mục tiêu, dự án'
    },
    moduleName: 'project',
    // itemsOrigin: [],
  }),
  actions: {
    ...projectStore.action,

    /**
     * NXHung gán lại giá trị itemOrigin sau khi load xong dữ liệu
     */
    // async exceuteAfterLoadFullCache() {
    //   this.itemsOrigin = this.items;
    // },

    // /**
    //  * Lưu biến items có đầy đủ thông tin sang bên itemsOrigin để có đầy đủ dữ liệu dùng khi cần do filter hiện nay đang lọc lại chính items
    //  * VDDONG 13/12/2023
    //  */
    // copyItemsOrigin() {
    //   let me = this;
    //   if (me.items && me.items.length > 0) {
    //     me.itemsOrigin = _.cloneDeep(me.items);
    //   }
    // },

    /**
     * Thêm mới dữ liệu công trình
     * VDDONG
     */
    postDataConstruction(param) {
      return ProjectAPI.saveConstruction(param);
    },

    // /**
    //  * Load dữ liệu tree và điều kiện lọc (lấy full theo filter)
    //  * VDDONG 24/05/2023
    //  */
    // async loadTreeFilters(itemsOrigin, filters) {
    //   const me = this;
    //   this.items = itemsOrigin;
    //   try {
    //     me.loading = true;
    //     const filterObjectType = [];
    //     const filterActive = [];
    //     for (let i = 0; i < filters.length; i++) {
    //       if (filters[i].field == 'object_type' && filters[i].value != resouce.All) {
    //         filterObjectType.push(filters[i]);
    //       }
    //       if (filters[i].field == 'active' && filters[i].value != resouce.All) {
    //         filterActive.push(filters[i]);
    //       }
    //     }
    //     if (filterObjectType.length > 0) {
    //       this.items = this.items.filter(i => i.object_type == filterObjectType[0].value);
    //     }
    //     if (filterActive.length > 0) {
    //       this.items = this.items.filter(i => i.active == filterActive[0].value);
    //     }
    //   } finally {
    //     me.loading = false;
    //   }
    // },
  },
  getters: {
    ...projectStore.getters,
  },
});
